<template>
  <div class="policy-view">
     <phone-view :phones="state.items"></phone-view>
  </div>
</template>
<script setup>
import phoneView from '@/components/phoneView.vue';
import img01 from '@/assets/images/tujie/tujie01.png';
import img02 from '@/assets/images/tujie/tujie02.png';
import img03 from '@/assets/images/tujie/tujie03.png';
import img04 from '@/assets/images/tujie/tujie04.jpg';
import img05 from '@/assets/images/tujie/tujie05.jpg';
import img06 from '@/assets/images/tujie/tujie06.png';
import img07 from '@/assets/images/tujie/tujie07.png';
import img08 from '@/assets/images/tujie/tujie08.png';
import { reactive } from 'vue-demi';
const state = reactive({
  items:[
    {
            key: 'xx',
            img: img01
          },
          {
            key: 'xx2',
            img: img02
          },
          {
            key: 'xx3',
            img: img03
          },
          {
            key: 'xx4',
            img: img04
          },
          {
            key: 'xx05',
            img: img05
          },
          {
            key: 'xx06',
            img: img06
          },
          {
            key: 'xx07',
            img: img07
          },
          {
            key: 'xx08',
            img: img08
          }
  ]
})
</script>
<style lang="less" scoped>
.policy-view{
  padding:24px 0 60px;
}
</style>